export const generateVideoCallErrorLog = (callId, error, location, additionalInfo = {}) => {
  return {
    additional_info: additionalInfo,
    call_id: callId,
    client: "web",
    error: error.toString(),
    location: location,
    stack: error.stack,
  };
};
